export default __webpack_public_path__ + "static/media/bannerMobile.d0712c0d.jpeg";